export enum CustomerSegmentType {
  SYSTEM_SUBMITTED = 'SYSTEM:SUBMITTED',
  SYSTEM_ALL = 'SYSTEM:ALL',
  USER_CREATED = 'USER:CREATED',
}

export const isSystemSegment = (type?: string) => {
  return type?.startsWith('SYSTEM:')
}
